import React, { useState, useEffect } from 'react';
import { CardHeader, Button, CardBody, Collapse, Card, CustomInput } from 'reactstrap';
import { BeatLoader } from 'react-spinners';
import { withRouter } from 'react-router-dom';
import { generatePath } from "react-router";

const RubroFilter = (props) => {
  const { filter, onChangeFilter } = props;
  const toggle = () => onChangeFilter(filter.identifier, filter.code, filter.checked);
  return (
    <div className="pl-5">
      <CustomInput
        type="checkbox"
        id={`filtro-filter-${filter.code}`}
        label={filter.Nombre}
        checked={filter.checked}
        onClick={(evt) => {
          evt.preventDefault();
          setTimeout(toggle, 100);
        }}
      />
    </div>
  )
}

const GrupoFilter = (props) => {
  const { filter, onChangeFilter, removeCodesFromUrl } = props;
  const toggle = () => {
    if (filter.checked && filter.Opciones) {
      let filters = [`${filter.identifier}${filter.code}`];
      filter.Opciones.forEach(rubro => filters.push(rubro.identifier + rubro.code));
      removeCodesFromUrl(filters);
    } else {
      onChangeFilter(filter.identifier, filter.code, filter.checked);
    }
  };
  return (
    <div className="ml-2 border-top">
      <CustomInput
        type="checkbox"
        id={`filtro-grupo-${filter.code}`}
        label={filter.Nombre}
        checked={filter.checked}
        onClick={(evt) => {
          evt.preventDefault();
          setTimeout(toggle, 100);
        }}
      />
      {
        filter.checked && filter.Opciones && filter.Opciones.map(rubro => <RubroFilter key={`rubro-filter-${rubro.code}`} {...props} filter={rubro} />)
      }
    </div>
  );
}

const GruposFilter = (props) => {
  const { filter, loading } = props;
  return !loading && filter && filter.Opciones && filter.Opciones.length > 0 && (
    <>
      {
        filter.Opciones.map(grupo => (<GrupoFilter key={`grupo-filter-${grupo.code}`} {...props} filter={grupo} />))
      }
    </>
  );
}

export default withRouter(GruposFilter);